<div class="lui-selector-search">
  <ng-content select="mat-form-field"></ng-content>
</div>
<div class="lui-selector-options">
  <ng-content></ng-content>
</div>
